import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KeyControlDetailCardComponent } from './key-control-detail-card.component';

@NgModule({
  declarations: [KeyControlDetailCardComponent],
  exports: [
    KeyControlDetailCardComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class KeyControlDetailCardModule { }
